import { reactive } from 'vue';
import { createInternalConfiguratorApi, createExternalConfiguratorApi } from './ConfiguratorApi';

export const CONFIGURATOR_CONTEXT = 'configuratorContext';
export const INTERNAL = 'INTERNAL';
export const EXTERNAL = 'EXTERNAL';

export function createInternalConfiguratorContext({ getUser, getCompany, getProject }) {
  return {
    mode: INTERNAL,
    get project() { return getProject(); },
    get loggedInUser() { return getUser(); },
    get company() { return getCompany(); },
    get identityView() { return getUser(); },
    capabilities: null,
    api: createInternalConfiguratorApi(getProject),
  };
}

export function createExternalConfiguratorContext(started, client) {
  const caps = started.context?.capabilities;
  const keys = ['pricingMode', 'checkoutMode', 'showPrices', 'allowedCategories', 'restrictCategories', 'allowImages'];
  if (!caps || Object.keys(caps).length !== keys.length || keys.some(key => !(key in caps))
      || caps.pricingMode !== 'LIST_PRICE' || caps.checkoutMode !== 'EXTERNAL_TRANSFER'
      || ['showPrices', 'restrictCategories', 'allowImages'].some(key => typeof caps[key] !== 'boolean')
      || !Array.isArray(caps.allowedCategories) || caps.allowedCategories.some(key => typeof key !== 'string')
      || !Number.isSafeInteger(started.project?.id) || started.project.id < 1
      || !Number.isSafeInteger(started.project?.revision) || started.project.revision < 0) {
    throw new Error('Der Server hat keinen gültigen Integrationskontext geliefert.');
  }
  const context = reactive({
    mode: EXTERNAL,
    project: { id: started.project.id, integration_revision: started.project.revision },
    identityView: Object.freeze({
      externalSubject: started.context.externalSubject,
      customerKey: started.context.customerKey,
    }),
    capabilities: Object.freeze({ ...caps, allowedCategories: Object.freeze([...caps.allowedCategories]) }),
    loggedInUser: null,
    company: null,
    catalog: null,
    pendingWrites: 0,
    api: null,
  });
  context.api = createExternalConfiguratorApi(client, context);
  return context;
}

export function requiresUnsupportedPowderFee(config) {
  const pricing = config?.ralPricing;
  return config?.type === 'powder_fee' || (!!pricing?.key
    && pricing.powderFee !== null && pricing.powderFee !== undefined && pricing.powderFee !== '');
}

export function integrationErrorMessage(error) {
  const status = error?.response?.status;
  if (status === 401) return 'Die Integrationssession ist abgelaufen oder wurde beendet. Bitte die Demo neu starten.';
  if (status === 409) return 'Das Projekt wurde inzwischen geändert. Der gespeicherte Stand wurde neu geladen. Bitte die Änderung prüfen.';
  if (status === 426) return 'Diese Frontendversion ist zu alt. Bitte die Seite neu laden.';
  if (status === 422) return 'Die Konfiguration konnte nicht gespeichert werden. Bitte Produkt, Menge und Eingaben prüfen.';
  return 'Die Änderung konnte nicht bestätigt werden. Bitte den gespeicherten Projektstand neu laden.';
}
